import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Flex,
  Grid,
  Text,
  SimpleGrid,
  Spinner,
  useColorModeValue,
} from "@chakra-ui/react";
import Banner from "views/admin/marketplace/components/Banner";
import Network from "components/card/Network";
import useEndpoints from "providers/Endpoints";
import constants from "providers/Constants";

export default function Networks() {
  const { t } = useTranslation();
  const [networks, setNetworks] = useState([]);
  const [loading, setLoading] = useState(true);

  const textColor = useColorModeValue("secondaryGray.900", "white");

  const endpoints = useEndpoints();

  useEffect(() => {
    getNetworks();
  }, []);

  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      <Grid
        mb="20px"
        gridTemplateColumns={{ base: "1fr" }}
        gap={{ base: "20px", xl: "20px" }}
        display={{ base: "block", xl: "grid" }}
      >
        <Flex flexDirection="column">
          <Banner />
          <Flex direction="column">
            <Text
              mt="45px"
              mb="36px"
              color={textColor}
              fontSize="2xl"
              ms="24px"
              fontWeight="700"
            >
             {t('Crypto Networks')}
            </Text>
            {loading ? (
              <Flex justifyContent="center" alignItems="center" height="200px">
                <Spinner size="xl" />
              </Flex>
            ) : (
              <SimpleGrid
                columns={{ base: 1, md: 4 }}
                gap="20px"
                mb={{ base: "20px", xl: "0px" }}
              >
                {networks.map((network, index) => (
                  <Network
                    key={index}
                    name={network?.currency_name}
                    author={network?.currency_short}
                    bidders={network?.mode}
                    image={network?.avatar}
                    currentbid={network?.address_type}
                    download={network?.address_type}
                    payload={network}
                  />
                ))}
              </SimpleGrid>
            )}
          </Flex>
        </Flex>
      </Grid>
    </Box>
  );

  async function getNetworks() {
    endpoints.getNetworks((error, data) => {
      if (error) {
        constants.showToast(
          "error",
          t('FAILED'),
          error?.message || t('Snap! Something went wrong, Try again')
        );
      } else {
        setNetworks(data);
      }
      setLoading(false);
    });
  }
}
